<template>
    <vs-popup :active.sync="isActive"  @update:active="handlePopupUpdate" title="Gün Açılışı">
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
<h3>Lütfen kasadaki mevcut nakit miktarını sayarak gün açılışını yapınız.</h3>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
           <vs-input id="Nakit" name="Nakit" v-validate="'required'" v-model="safeCash" label-placeholder="Kasa Anlık Nakit: " @input="handleInput">

            </vs-input>

          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
          <span style="text-align: center;" class="text-danger text-sm" v-show="errors.has('Nakit')">{{ errors.first('Nakit') }}</span>
        </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">

          <vs-col vs-type="flex" vs-w="12" vs-justify="center">
            <vs-button @click="showPopup" size="large" color="transparent" class="bold bg-success text-white ml-2">
              Onayla
            </vs-button>
          </vs-col>
        </vs-row>
      <!-- Kapatma olayını durdurmak için -->
      <template v-slot:popup-content="{ popup }">
        <div @click.stop="preventCloseOnClick" v-html="popup.content"></div>
      </template>
      <div fullscreen style="z-index: 9999999;" class="popup-overlay" v-if="showPopupFlag">
        <div fullscreen class="popup">
          <h3>Kasa açılış nakit miktarı {{safeCash}} TL olarak kaydedilecektir, onaylıyor musunuz?</h3>
          <button class="btn btn-primary" @click="forcelose">Onaylıyorum</button>
          <button class="btn btn-secondary" @click="closePopup">İptal</button>
        </div>
      </div>
    </vs-popup>
  </template>

  <script>
  import {
    createDayOpen
  } from "@/api/DayOpen.js";
  import companyInfo from "../../../model/constants/companyInfo";
  export default {
    data() {
      return {
        isActive: false, // Pop-up'ı başlangıçta açık tutmak için
        logo: companyInfo.logo,
        showPopupFlag: false,
        safeCash: 0
      };
    },
    computed:{
      activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    }
    },
    methods: {
        handleInput() {
      // Girilen değeri kontrol et
      if (this.safeCash !== null) {
        // Sayı ve en fazla iki ondalık basamak kontrolü
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.safeCash)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.safeCash = this.safeCash.slice(0, -1); // En son karakteri siler
        }
      }
    },
        showPopup: async function () {
          let checker = await this.$validator.validateAll();
         if (!checker) {
          return;
         }
        this.showPopupFlag = true
      },
        closePopup() {
        this.showPopupFlag = false;
      },
        forcelose: async function () {
          createDayOpen({safeCash :this.safeCash, userId:this.$currentUser.id,
             userName: this.$currentUser.name })
          this.$emit("emitGetBranchOpenClose", true);
            this.isActive = false;
        },
      preventCloseOnClick() {
        // İhtiyaca göre özel mantık ekleyebilirsiniz
      },
      handlePopupUpdate(newValue) {
      // Pop-up durumu güncellendiğinde tetiklenir
      if (!newValue) {
        // Pop-up kapatıldığında yapılacak işlemler
        this.isActive = true; // Pop-up'ı tekrar açmak için
      }
    },
    },
  };
  </script>
  <style>

  .logo{
    background-color: white;
       border-radius: 10px;
    margin-bottom: 1rem;
  }
  #switchScreen{
    z-index: 999999;
  }
  #switchScreen .vs-popup .vs-popup--header {
    display: none !important;
  }

  #switchScreen .vs-popup .vs-popup--content {
    padding: 0 !important;
    /*height: 47vh;*/
  }

  #switchScreen .vs-popup {
    background: transparent !important;
    box-shadow: none !important;
  }

  #switchScreen input {
    font-size: 2rem !important;
    background: #f2f2f2 0% 0% no-repeat padding-box !important;
    text-align: center !important;
    padding: 0.5rem;
  }
  </style>
